/*
 * <custom-size-fields>
 * Reveals + enables the custom measurement/note inputs only when the shopper
 * selects the "Add custom size" size value. While hidden the inputs stay
 * disabled so their (empty) line item properties are never submitted for a
 * standard size.
 */
if (!customElements.get('custom-size-fields')) {
  customElements.define(
    'custom-size-fields',
    class CustomSizeFields extends HTMLElement {
      connectedCallback() {
        this.triggerValue = (this.dataset.triggerValue || 'Add custom size')
          .trim()
          .toLowerCase();

        // Watch variant option changes within the surrounding product section.
        this.scope = this.closest('.shopify-section') || this.closest('form') || document;
        this._onChange = this._onChange.bind(this);
        this.scope.addEventListener('change', this._onChange);

        this.update();
      }

      disconnectedCallback() {
        if (this.scope) this.scope.removeEventListener('change', this._onChange);
      }

      _onChange(event) {
        const el = event.target;
        if (el && (el.matches('input[type="radio"]') || el.matches('select'))) {
          this.update();
        }
      }

      isCustomSelected() {
        const matches = (value) =>
          (value || '').trim().toLowerCase() === this.triggerValue;

        // Pill / swatch style renders option values as checked radios.
        const radios = this.scope.querySelectorAll('input[type="radio"]:checked');
        for (const radio of radios) {
          if (matches(radio.value)) return true;
        }

        // Dropdown style renders option values inside a <select>.
        const selects = this.scope.querySelectorAll('select');
        for (const select of selects) {
          if (matches(select.value)) return true;
        }

        return false;
      }

      update() {
        const active = this.isCustomSelected();
        this.hidden = !active;
        this.querySelectorAll('input, textarea, select').forEach((field) => {
          field.disabled = !active;
        });
      }
    }
  );
}
